import React, { useState, useEffect } from "react";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { useFormik } from "formik";
import classNames from "classnames";
import { handleGetRequest } from "../../../services/GetTemplate";
import { handlePostRequest } from "../../../services/PostTemplate";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import * as Yup from "yup";
import { Dialog } from "primereact/dialog";
import ReviewTransactionDetail from "./ReviewTransactionDetail";

function ReviewTransaction() {
    const [loading, setloading] = useState(false);
    const [loadingIcon, setloadingIcon] = useState("pi pi-save");
    const [productName, setProductName] = useState([]);
    const [companyName, setCompanyName] = useState([]);
    const [companyId, setCompanyId] = useState("");
    const [reviewDetailData, setReviewDetailData] = useState([]);
    const [displayModal, setDisplayModal] = useState(false);
    const [reviewTransactionDetails, setRreviewTransactionDetails] = useState([]);
    const [authDetails, setAuthDetails] = useState("");

    const getCompanyName = async () => {
        setloading(true);
        const response = await handleGetRequest("zbizgateway/lov/lovAuthCompany");
        setCompanyName(response?.data);
        setloading(false);
    };

    useEffect(() => {
        getCompanyName();
    }, []);

    const handleCompany = (companyId) => {
        setCompanyId(companyId);
        getProductName(companyId);
    };
    const authorizationStatus = [
        { code: "A", name: "Approved" },
        { code: "R", name: "Reject" },
        { code: "I", name: "In Progress" },
    ];
    const handleReviewDetail = async (reviewDetail) => {
        const res = await handlePostRequest({ transHeadId: reviewDetail?.transHeadId }, "zbizgateway/nonFin/reviewTransactionDetail");
        setRreviewTransactionDetails(res?.data);
        setAuthDetails(res?.data?.authDetails);

        setDisplayModal(true);
    };
    const getProductName = async (companyId) => {
        setloading(true);
        const response = await handleGetRequest(`zbizgateway/lov/lovAuthCompanyProduct/${companyId}`);
        setProductName(response?.data);
        setloading(false);
    };

    const actionTemplate = (rowData) => {
        return (
            <div>
                <Button
                    tooltip="View Details"
                    icon="pi pi-eye"
                    tooltipOptions={{ position: "top" }}
                    onClick={(e) => {
                        handleReviewDetail(rowData);
                    }}
                    className="p-button-rounded p-button-primary p-mr-2"
                />
            </div>
        );
    };
    const validationSchema = Yup.object().shape({
        companyName: Yup.mixed().required("This field is required"),
        productName: Yup.mixed().required("This field is required"),
        authStatus: Yup.mixed().required("This field is required"),
        fromDate: Yup.mixed().required("This field is required"),
        toDate: Yup.mixed().required("This field is required"),
    });
    const authDateValidation = (rowData) => {
        return rowData?.authDate?.slice(0, 10);
    };
    const transferDateValidation = (rowData) => {
        return rowData?.transDate?.slice(0, 10);
    };
    const formik = useFormik({
        validationSchema: validationSchema,
        initialValues: {
            companyName: null,
            productName: null,
            fromDate: null,
            toDate: null,
            authStatus: null,
        },
        onSubmit: async (data) => {
            setloading(true);
            setloadingIcon("pi pi-spin pi-spinner");
            data["companyId"] = companyId;
            data["productId"] = data?.productName?.id;
            data["authStatus"] = data?.authStatus?.code;
            delete data["companyName"];
            delete data["productName"];
            const res = await handlePostRequest(data, "zbizgateway/nonFin/reviewTransaction");
            if (res?.status === 400) {
                res?.data.forEach((element) => {
                    formik.setFieldError(element?.field, element?.message);
                });
            } else if (res?.responsecode === 1) {
                setReviewDetailData(res?.data);
            }
            setloading(false);
            setloadingIcon("pi pi-save");
        },
    });

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    return (
        <>
            <Dialog visible={displayModal} style={{ width: "90%" }} onHide={() => setDisplayModal(false)}>
                <ReviewTransactionDetail reviewTransactionDetails={reviewTransactionDetails} authDetails={authDetails} />
            </Dialog>
            <div className="card Card__Round">
                <div className="Form__Header">
                    <h1>Review Transaction</h1>
                </div>
                <form onSubmit={formik.handleSubmit} className="p-fluid p-mt-2">
                    <div className="p-fluid p-formgrid p-grid">
                        <div className="p-field p-col-12 p-md-4">
                            <div className="p-field">
                                <label htmlFor="companyName" className={classNames({ "p-error": isFormFieldValid("companyName") }, "Label__Text")}>
                                    Company Name<span className="Label__Required">*</span>
                                </label>
                                <Dropdown
                                    id="companyName"
                                    placeholder="Select"
                                    options={companyName}
                                    optionLabel="description"
                                    name="companyName"
                                    value={formik.values.companyName}
                                    onChange={(e) => {
                                        formik.handleChange(e);
                                        handleCompany(e?.value?.id);
                                    }}
                                    className={classNames({ "p-invalid": isFormFieldValid("companyName") }, "Dropdown__Round")}
                                />
                                {getFormErrorMessage("companyName")}
                            </div>
                        </div>
                        <div className="p-field p-col-12 p-md-4">
                            <div className="p-field">
                                <label htmlFor="productName" className={classNames({ "p-error": isFormFieldValid("productName") }, "Label__Text")}>
                                    Product Name<span className="Label__Required">*</span>
                                </label>

                                <Dropdown
                                    id="productName"
                                    placeholder="Select"
                                    options={productName}
                                    optionLabel="description"
                                    name="productName"
                                    value={formik.values.productName}
                                    onChange={formik.handleChange}
                                    className={classNames({ "p-invalid": isFormFieldValid("productName") }, "Dropdown__Round")}
                                />
                                {getFormErrorMessage("productName")}
                            </div>
                        </div>
                        <div className="p-field p-col-12 p-md-4">
                            <div className="p-field">
                                <label htmlFor="fromDate" className={classNames({ "p-error": isFormFieldValid("fromDate") }, "Label__Text")}>
                                    Form Date
                                </label>
                                <InputText id="fromDate" placeholder="928364" type="date" name="fromDate" value={formik.values.fromDate} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("fromDate") }, "Input__Round")} />

                                {getFormErrorMessage("fromDate")}
                            </div>
                        </div>
                        <div className="p-field p-col-12 p-md-4">
                            <div className="p-field">
                                <label htmlFor="toDate" className={classNames({ "p-error": isFormFieldValid("toDate") }, "Label__Text")}>
                                    To Date.
                                </label>
                                <InputText id="toDate" type="date" placeholder="91826528" name="toDate" value={formik.values.toDate} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("toDate") }, "Input__Round")} />

                                {getFormErrorMessage("toDate")}
                            </div>
                        </div>
                        <div className="p-field p-col-12 p-md-4">
                            <div className="p-field">
                                <label htmlFor="authStatus" className={classNames({ "p-error": isFormFieldValid("authStatus") }, "Label__Text")}>
                                    Authorization Status<span className="Label__Required">*</span>
                                </label>

                                <Dropdown
                                    id="authStatus"
                                    placeholder="Select"
                                    options={authorizationStatus}
                                    optionLabel="name"
                                    name="authStatus"
                                    value={formik.values.authStatus}
                                    onChange={formik.handleChange}
                                    className={classNames({ "p-invalid": isFormFieldValid("authStatus") }, "Dropdown__Round")}
                                />
                                {getFormErrorMessage("authStatus")}
                            </div>
                        </div>
                    </div>
                    <div className="Down__Btn">
                        <Button disabled={loading} icon={loadingIcon || ""} iconPos="right" label="Fetch" className="Btn__Dark" />
                    </div>
                </form>
            </div>

            <div className="card p-datatable-sm">
                <DataTable header="" loading={loading} value={reviewDetailData} paginator rows={3} emptyMessage="No data found.">
                    <Column field="companyName" header="Company Name" />
                    <Column field="masterProductName" header="Product Name" />
                    <Column field="2022-02-29" body={transferDateValidation} header="Transfer Date" />
                    <Column field="transAmount" header="Transfer Amount" />
                    <Column field="createUser" header="Create User" />
                    <Column field="authStatus" header="Authorization Status" />
                    <Column field="authDate" body={authDateValidation} header="Authorization Date" />
                    <Column field="authUser" header="Authorization User" />
                    <Column field="authComments" header="Auhtorization Comments" />
                    <Column body={actionTemplate} field="areaCode" header="" />
                </DataTable>
            </div>
        </>
    );
}

export default ReviewTransaction;
